import { schema } from "normalizr";
import { ItemSchema } from "@modules/inventory/item/item/schema";

const StockOutItemSchema = new schema.Entity("stockOutItems", {
  item: ItemSchema,
});

const StockOutItemArraySchema = new schema.Array(StockOutItemSchema);

export { StockOutItemSchema, StockOutItemArraySchema };